import React from "react";
import "./SpotlightMedia.css";
import {
  FaInstagram,
  FaYoutube,
  FaFacebookF,
  FaLinkedinIn,
  FaMapMarkerAlt,
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6"; // ✅ X icon

const announcements = [
  "New Academic Session commences from 1st April 2026.",
  "First Parent Teacher Association meeting is on 18th April 2026.",
  "Term -1 Fee to be paid by 20th April 2026",
  "Half day Schedule for the month of April : 8:30 A.M - 12:00 P.M",
  "Academic planner for the month of April 2026-27 will be posted by 30thMarch 2026.",
];

const circulars = [
  { title: "Exam Time Table", desc: "Download schedule for Summative Exams", link: "#" },
  { title: "Sports Day Circular", desc: "Guidelines & event participation list", link: "#" },
  { title: "Field Trip Circular", desc: "Timings & materials to be carried", link: "#" },
];

const SpotlightMedia = () => {
  return (
    <section className="sm-container">
      <h1 className="sm-title">SPOTLIGHT & MEDIA</h1>

      {/* Announcements */}
      <h2 className="section-title">📢 Announcements</h2>
      <div className="announcement-card">
        <div className="announce-ticker">
          <div className="ticker-move">
            {announcements.map((a, i) => (
              <p key={i}>🔔 {a}</p>
            ))}
          </div>
        </div>
      </div>

      {/* Circulars */}
      <h2 className="section-title">📄 Circulars</h2>
      <div className="circular-grid">
        {circulars.map((c, i) => (
          <div className="circle-card" key={i}>
            <div className="front">
              <h3>{c.title}</h3>
            </div>
            <div className="back">
              <p>{c.desc}</p>
              <a href={c.link} target="_blank" rel="noreferrer">
                Download PDF →
              </a>
            </div>
          </div>
        ))}
      </div>

      {/* Social Media */}
      <h2 className="section-title">🌐 Connect With Us</h2>

      {/* one card */}
      <div className="social-ticker">
        <div className="social-track">
          <a
            className="social-icon-link insta"
            href="https://www.instagram.com/vvcreativemindsschool/"
            target="_blank"
            rel="noreferrer"
            aria-label="Instagram"
            title="Instagram"
          >
            <FaInstagram />
          </a>

          <a
            className="social-icon-link youtube"
            href="https://www.youtube.com/@VVCreativeMindsSchool"
            target="_blank"
            rel="noreferrer"
            aria-label="YouTube"
            title="YouTube"
          >
            <FaYoutube />
          </a>

          <a
            className="social-icon-link facebook"
            href="https://www.facebook.com/vvcreativemindsschool"
            target="_blank"
            rel="noreferrer"
            aria-label="Facebook"
            title="Facebook"
          >
            <FaFacebookF />
          </a>

          <a
            className="social-icon-link twitter"
            href="https://x.com/VVCREATIVEMINDS"
            target="_blank"
            rel="noreferrer"
            aria-label="X"
            title="X"
          >
            <FaXTwitter />
          </a>

          <a
            className="social-icon-link linkedin"
            href="https://www.linkedin.com/company/vv-creative-minds-school"
            target="_blank"
            rel="noreferrer"
            aria-label="LinkedIn"
            title="LinkedIn"
          >
            <FaLinkedinIn />
          </a>

          <a
            className="social-icon-link location"
            href="https://www.google.com/maps"
            target="_blank"
            rel="noreferrer"
            aria-label="Google Location"
            title="Google Location"
          >
            <FaMapMarkerAlt />
          </a>
        </div>
      </div>
    </section>
  );
};

export default SpotlightMedia;
